import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, AlertController, LoadingController } from '@ionic/angular/lazy';
import { CashTrackingService } from 'src/app/services/cash-tracking.service';
import { StorageService } from 'src/app/services/storage.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-cash-tracking-end-tracking',
    templateUrl: './cash-tracking-end-tracking.page.html',
    styleUrls: ['./cash-tracking-end-tracking.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CashTrackingEndTrackingPage implements OnInit {

    @Input() cash_tracking_page = null;
    printer_paper_sizes = [];

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private cashTrackingService: CashTrackingService,
        public loadingController: LoadingController,
        private storageService: StorageService,
        public permissionService: PermissionService
    ) { }

    ngOnInit() {


        this.storageService.get("printer_paper_sizes").then((printer_paper_sizes) => {
            if(printer_paper_sizes) {
                this.printer_paper_sizes = printer_paper_sizes;
            }
        })
        .catch(() => {});

    }

    close() {
        this.modalController.dismiss();
    }

    printCashTrackingReport(printer_paper_size) {
        this.cash_tracking_page.printCashTrackingReport(printer_paper_size);
    }

    end() {
        this.cashTrackingService.deleteCashTracking().then(() => {
            this.modalController.dismiss();
        });
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            cssClass:'alert',
            buttons: ['OK']
        });
        await alert.present();
    }

}
